import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 3.75rem;
  padding: 1rem 2rem;

  background-color: var(--secondary-color);

  img {
    width: auto;
    height: 100%;
  }

  button {
    all: unset;
    height: 100%;
    cursor: pointer;

    color: white;
  }
`;
